<template>
  <div :class="$style['health-order-message-all']">
    <template v-if="isImmuneStorage">
      <table>
        <template v-if="fieldsArrOfCustomer.length">
          <div>客户信息</div>
          <template v-for="(item,index) in fieldsArrOfCustomer">
            <pt-message-table-item :label="item.label" :key="index" v-if="item.key!=='organizationId'">
              {{itemData(customerInfo,item)}}
              <!-- {{data[item.key]}} -->
            </pt-message-table-item>
          </template>
        </template>
      </table>
      <table>
        <template v-if="fieldsArrOfImmuneStorage.length">
          <div v-for="(etem,i) in fieldsArrOfImmuneStorage" :key="i">
            <div>存储人{{i+1}}信息</div>
            <pt-message-table-item v-for="(item,index) in etem" :label="item.label" :key="i+'_'+index">
              {{itemData(storePersonInfos[i],item)}}
            </pt-message-table-item>
          </div>
        </template>
      </table>
    </template>
    <table :class="$style['health-order-message']" v-else>
      <pt-message-table-item v-for="(item,index) in fieldsArr" :label="item.label" :key="index">
        {{itemData(genericFormData,item)}}
        <!-- {{data[item.key]}} -->
      </pt-message-table-item>
    </table>
    <!-- <el-button type="primary" @click="editHealthMessage" v-if="showEditButton">编辑</el-button> -->
    <el-dialog :visible.sync="is_dialog" width="30%" @close="closeDialog" title="编辑报名地区信息">
      <health-message-edit :genericFormData="genericFormData" v-if="is_edit" @closeDialog="closeDialog" :mallOrderId="mallOrderId"></health-message-edit>
    </el-dialog>
  </div>
</template>
<script>
import healthMessageEdit from './health-message-edit'
import { itemFiledsData } from 'cps/appointment-application/utils-filed'
import { hasPermissions } from 'utils/permissions'
const PERM_MALL_ORDER_EDIT = 'PERM_MALL_ORDER_EDIT'
export default {
  props: {
    userRegistration: {
      type: Object
    },
    registrationEvent: {
      type: Object
    },
    mallOrderId: {
      type: String
    },
    isEdit: Boolean
  },
  computed: {
    isImmuneStorage () {
      return this.userRegistration.eventType === 'IMMUNE_STORAGE'
    },
    storePersonInfos () {
      return this.userRegistration.allFormData.storePersonInfos || []
    },
    customerInfo () {
      let allFormData = JSON.parse(JSON.stringify(this.userRegistration.allFormData))
      this.$delete(allFormData, 'storePersonInfos')
      return this.userRegistration.allFormData.customerInfo || allFormData || {}
    },
    genericFormData () {
      return (this.userRegistration.genericFormData && this.userRegistration.genericFormData && this.userRegistration.genericFormData.data) || {}
    },
    fieldsArr () {
      return (this.registrationEvent && this.registrationEvent.form && this.registrationEvent.form.fields) || []
    },
    fieldsArrOfCustomer () {
      let arr = []
      this.fieldsArr.forEach(item => {
        for (let key in this.customerInfo) {
          if (key === item.key) {
            arr.push(item)
          }
        }
      })
      return arr
    },
    fieldsArrOfImmuneStorage () {
      let arr = []
      let allArr = []
      if (this.storePersonInfos && this.storePersonInfos.length) {
        this.fieldsArr.forEach(item => {
          for (let key in this.storePersonInfos[0]) {
            if (key === item.key) {
              arr.push(item)
            }
          }
        })
      }
      for (let i = 0; i < this.storePersonInfos.length; i++) {
        allArr.push(arr)
      }
      return allArr
    },
    is_dialog: {
      get: function () {
        return this.is_edit
      },
      set: function (val) {
        this.is_edit = val
      }
    },
    HAS_PERM_MALL_ORDER_EDIT () {
      return hasPermissions(this.$auth.user() && this.$auth.user().permissions, PERM_MALL_ORDER_EDIT)
    },
    showEditButton () {
      return this.HAS_PERM_MALL_ORDER_EDIT && this.mallOrderId && this.isEdit
    }
  },
  components: {
    healthMessageEdit
  },
  data () {
    return {
      is_edit: false
    }
  },
  methods: {
    closeDialog (val) {
      this.is_dialog = false
      if (val) {
        this.$emit('refreshDetail')
      }
    },
    itemData (data, val) {
      return itemFiledsData(data, val)
    },
    editHealthMessage () {
      this.is_edit = true
    }
  }
}
</script>
<style module lang="less">
.health-order-message{
    padding: 0 20px
}
.health-order-message-all{
	padding: 0 20px;
  :global{
  .el-dialog{
    width: 50%;
    min-width: 450px;
    .el-dialog__body{
      padding: 15px 20px;
    }
  }
  .el-button{
    margin-left: 20px;
  }
  }
}
</style>
